module.exports = __webpack_public_path__ + "img/manual-registration-vs-aconex-accelerator.fa4a0fed.png";